import { SafeJSON } from './../../shared/safe-json';

export class Attorney {
    private json: any;
    private key: string;

    constructor(json: any, key: string) {
        this.json = json;
        this.key = key;
    }
    getKey(): string {
        return this.key;
    }
    getAttorneyName(): string {
        return SafeJSON.get('name', this.json);
    }
    getBarNumber(): string {
        let barNumber = SafeJSON.get('barNumber', this.json);
        const num = this.convertToNumber(barNumber);
        barNumber = num.toString();
        return barNumber;
    }
    convertToNumber(jsonField: string): number {
        if (jsonField === '') {
            return 0;
        }
        const num = Number.parseInt(jsonField);
        return num;
    }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile-case-sections/attorney.ts